import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useApollo } from "@/apollo/client";
import { BreadcrumbsProvider } from "@/components/Breadcrumbs";
import { CopyrightsProvider } from "@/components/Copyrights";
import DefaultHeader from "@/components/DefaultHeader";
import Loading from "@/components/Loading";
import { ModalProvider } from "@/components/Modal";
import NetworkNotification from "@/components/NetworkNotification";
import { NotificationProvider } from "@/components/Notification";
import { PreviousPathProvider } from "@/components/PreviousPath";
import { RecaptchaV3Provider } from "@/components/RecaptchaV3";
import SelectProfile from "@/components/SelectProfile";
import { useAppInit, useBuildId, useRtoasterTrack } from "@/hooks";
import { Layout } from "@/layouts";
import config from "@/lib/config";
import maybeIPad from "@/lib/maybeIPad";
import routes from "@/lib/routes";
import "@/styles/globals.scss";
import { ApolloProvider } from "@apollo/client";
import classnames from "classnames";
import Error from "next/error";
import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect, useMemo } from "react";
import "text-security/text-security.css";
import "url-search-params-polyfill";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const cssVariablesIE11Polyfill = {
  __html: `
      if (window.MSInputMethodContext && document.documentMode) {
        var script = "\<script src='https://cdn.jsdelivr.net/gh/nuxodin/ie11CustomProperties@4.1.0/ie11CustomProperties.min.js'><script>";
        document.write(script);
      }
    `
};
function InnerApp(props) {
  const {
    loading,
    user,
    selectedProfile,
    deviceInfo
  } = useAppInit();
  const router = useRouter();
  useRtoasterTrack(props === null || props === void 0 ? void 0 : props.referer);
  const showSelectProfile = useMemo(() => {
    if (router.pathname === routes.profilePincodeReset) return false;
    return !loading && user && !selectedProfile;
  }, [loading, user, selectedProfile, router.pathname]);
  const noHeader = useMemo(() => {
    if (router.pathname.includes("/device/activation")) return false;
    return props.noHeader || user && !selectedProfile;
  }, [user, selectedProfile, props.noHeader]);
  return /*#__PURE__*/_jsxs("div", {
    id: "app",
    className: classnames({
      tablet: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isTablet) || maybeIPad(deviceInfo),
      mobile: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMobile
    }),
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !loading && /*#__PURE__*/_jsx(NotificationProvider, {
      children: /*#__PURE__*/_jsxs(Layout, {
        noHeader: noHeader,
        noTransition: props.noTransition,
        children: [/*#__PURE__*/_jsx(NetworkNotification, {}), !showSelectProfile && props.children, showSelectProfile && /*#__PURE__*/_jsx(SelectProfile, {
          backToPrevPath: true
        })]
      })
    })]
  });
}
function SpodApp(_ref) {
  let {
    Component,
    pageProps,
    router
  } = _ref;
  const {
    shouldReload
  } = useBuildId();
  const client = useApollo(pageProps.initialApolloState);
  const noHeader = Component.layout === "NoHeaderLayout";
  const noTransition = Component.noTransition;
  useEffect(() => {
    const handleRouteChange = async () => {
      if (await shouldReload()) {
        window.location.reload();
      }
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [shouldReload]);
  if (pageProps.error) {
    // TODO: カスタムエラーページ
    return /*#__PURE__*/_jsx(Error, {
      statusCode: pageProps.error.statusCode,
      title: pageProps.error.message
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      dangerouslySetInnerHTML: cssVariablesIE11Polyfill,
      strategy: "beforeInteractive"
    }, "ie11polyfill"), /*#__PURE__*/_jsx(Script, {
      src: "https://code.jquery.com/jquery-3.5.1.min.js",
      integrity: "sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=",
      crossOrigin: "anonymous"
    }, "jquery"), /*#__PURE__*/_jsx(Script, {
      src: config.streaks.js,
      strategy: "beforeInteractive"
    }, "streaksjs"), /*#__PURE__*/_jsx(Script, {
      type: "text/javascript",
      src: config.sbps.src
    }, "sbps"), /*#__PURE__*/_jsx(Script, {
      type: "text/javascript",
      src: config.sbps.src3ds
    }, "sbps-3ds"), /*#__PURE__*/_jsx(DefaultHeader, {
      metatags: pageProps === null || pageProps === void 0 ? void 0 : pageProps.metatags
    }), /*#__PURE__*/_jsx(ApolloProvider, {
      client: client,
      children: /*#__PURE__*/_jsx(PreviousPathProvider, {
        children: /*#__PURE__*/_jsx(BreadcrumbsProvider, {
          children: /*#__PURE__*/_jsx(CopyrightsProvider, {
            children: /*#__PURE__*/_jsx(ModalProvider, {
              children: /*#__PURE__*/_jsx(RecaptchaV3Provider, {
                children: /*#__PURE__*/_jsx(InnerApp, _objectSpread(_objectSpread({}, pageProps), {}, {
                  noHeader: noHeader,
                  noTransition: noTransition,
                  children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
                }))
              })
            })
          })
        })
      })
    })]
  });
}
export default SpodApp;